module.exports = __webpack_public_path__ + "static/home-bg-mobile-94ad8f6692907c26237e13eae6f1b9c0.jpg";